var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.courseDetail),expression:"courseDetail"}],staticClass:"course-detail"},[(this.$route.query.courseIndex ?
      (_vm.courseDetail.subCourses &&
      _vm.courseDetail.subCourses[Number(this.$route.query.courseIndex)] &&
      _vm.courseDetail.subCourses[Number(this.$route.query.courseIndex)]
        .audioType == 1) : _vm.courseDetail.audioType == 1
    )?_c('AudioDetail',{attrs:{"switchPlayingStatusType":_vm.switchPlayingStatusType,"handleAudioPlay":_vm.handleAudioPlay,"monitorAudioEnded":_vm.monitorAudioEnded,"playingStatusType":_vm.playingStatusType,"audioState":_vm.audioState,"audioList":_vm.audioList,"atSelectAudio":_vm.atSelectAudio,"switchAudio":_vm.switchAudio,"answerChapter":_vm.answerChapter}}):_vm._e(),(
    this.$route.query.courseIndex ?
      _vm.courseDetail.subCourses &&
      _vm.courseDetail.subCourses[Number(this.$route.query.courseIndex)] &&
      _vm.courseDetail.subCourses[Number(this.$route.query.courseIndex)]
        .audioType == 2 : _vm.courseDetail.audioType == 2
    )?_c('VideoDetail',{attrs:{"videoList":_vm.videoList,"atSelectVideo":_vm.atSelectVideo,"switchVideo":_vm.switchVideo}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }